module.exports = __webpack_public_path__ + "static/media/delete.4b981414.svg";